import { DEFAULT_VALUE } from "@/config";
/**获取船名 */
export const getShipName = (entity: { name?: string; cnName?: string; cnname?: string }) => {
    return entity.cnName || entity.cnname || entity.name || DEFAULT_VALUE;
};
